import { render, staticRenderFns } from "./workorder-detail-form.vue?vue&type=template&id=224b0936&"
import script from "./workorder-detail-form.vue?vue&type=script&lang=js&"
export * from "./workorder-detail-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports